var exports = {
  "x": "xaf9ae18d--1527c7--button",
};

module.exports = exports;
